import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export default function ConfirmDialog({ open, onOpenChange, title, description, onConfirm, testId }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId || "confirm-dialog"}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title || "Apakah Anda yakin?"}</AlertDialogTitle>
          <AlertDialogDescription>{description || "Tindakan ini tidak dapat dibatalkan."}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-dialog-cancel">Batal</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-dialog-confirm" onClick={onConfirm} className="bg-red-600 hover:bg-red-700">
            Ya, Lanjutkan
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
